import equalByNameAndAssetComponentId from '../../utils/equalByNameAndAssetComponentId';
import dateConverter from '../../../../utils/converters/date.converter';
import {i18n} from "../../../vue-i18n";

export default class SetTermination {
  constructor(assetComponentId, termination) {
    this.commandName = "SetTermination";


    this.assetComponentId = assetComponentId;

    this.termination = termination;

    if (this.termination == null) {
      this.description = `${i18n.t('CONTENT.events.no_termination')}`
    } else if (this.termination.isSure) {
      const convertedDate = dateConverter.convertToDate(this.termination.date);
      const convertedPaymentDate = dateConverter.convertToDate(this.termination.paymentDate);

      if(convertedPaymentDate === null) {
        this.description =
          `${i18n.t('CONTENT.events.isSureOnDate')} ${i18n.d(convertedDate)}`;
      } else {
        this.description =
          `${i18n.t('CONTENT.events.isSureOnDate')} ${i18n.d(convertedDate)} ${i18n.t('CONTENT.events.and_cost')} ${this.termination.rateValue} ${this.termination.rateCurrency} ${i18n.t('CONTENT.events.on_date')} ${i18n.d(convertedPaymentDate)}`;
      }
    } else {
      this.description = `${i18n.$t('CONTENT.events.isNotSure')}`
    }
  }
  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        AssetComponentId: this.assetComponentId,
        Termination: this.termination
      })
    }
  }

  equal = (other) => equalByNameAndAssetComponentId(this, other);
}
